import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis, useLenis } from "lenis/react";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Live from "@/pages/Live";
import Matchday from "@/pages/Matchday";
import Content from "@/pages/Content";
import About from "@/pages/About";
import Socials from "@/pages/Socials";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import Terms from "@/pages/legal/Terms";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <ReactLenis root options={{ lerp: 0.1, duration: 1.1, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/live" element={<Live />} />
              <Route path="/matchday" element={<Matchday />} />
              <Route path="/content" element={<Content />} />
              <Route path="/about" element={<About />} />
              <Route path="/socials" element={<Socials />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ReactLenis>
    </HelmetProvider>
  );
}

export default App;
